import { isRouteErrorResponse, useRouteError } from "react-router-dom";

import PageError from "@/shared/ui/errors/PageError";

const toError = (routeError: unknown): Error => {
	if (routeError instanceof Error) {
		return routeError;
	}

	if (isRouteErrorResponse(routeError)) {
		const status = routeError.status;
		const statusText = routeError.statusText || "Route error";
		return new Error(`${status}: ${statusText}`);
	}

	if (typeof routeError === "string" && routeError.trim().length > 0) {
		return new Error(routeError);
	}

	return new Error("Something went wrong while loading this page.");
};

export const RouteErrorBoundary = () => {
	const routeError = useRouteError();
	const error = toError(routeError);

	return (
		<PageError
			error={error}
			componentStack=""
			reset={() => {
				if (typeof window !== "undefined") {
					window.location.reload();
				}
			}}
		/>
	);
};

export default RouteErrorBoundary;
